import { Model } from "@ofqual/portal-core/core/types";
import { Attachment } from "./Attachment";

export type Qualification = {
  id: string;
  title: string;
  organisationId: string;
  organisationName: string;
  qualificationNumber: string;
  organisationReferenceNumber: string | null;
  linkToSpecification: string;
  qualLevel: string;
  qualSubLevel: string;
  qualLevelId: number;
  qualificationType: number | null;
  epaStandardId: number | null;
  qualGLH: number | null;
  qualTQT: number | null;
  qualCredit: number | null;
  qualSectorSubjectArea: number | null;
  overallGradingType: number | null;
  gradingScale: number | null;
  specialism: string | null;
  offeredInEngland: boolean;
  offeredInNorthernIreland: boolean;
  preSixteen: boolean;
  sixteenToEighteen: boolean;
  eighteenPlus: boolean;
  nineteenPlus: boolean;
  fundingInEngland: boolean;
  fundingInNorthernIreland: boolean;
  offeredInternationally: boolean | null;
  isThisQualificationPrivate: boolean | null;
  optionalRoutesToCompleteQual: string | null;
  qualMinimumGLH: number | null;
  qualMaximumGLH: number | null;
  reguationStartDate: string;
  operationalStartDate: string;
  qualificationReviewDate: string;
  operationalEndDate: string;
  certificationEndDate: string;
  entitlementFrameworkDesignation: number | null;
  niDiscountCode: string | null;
  gcseSizeEquivalence: number | null;
  gceSizeEquivalence: number | null;
  approvedForDELFundedProgramme: boolean | null;
  embargoDate: string;
  createdByUpn: string;
  createdByDisplayName: string;
  modifiedByUpn: string;
  modifiedByDisplayName: string;
  createdDate: string;
  modifiedDate: string;
  qualAssessmentMethods: number[];
  qualAttachments: Attachment[];
  files: File[];
  availabilityStatus: string;
  approvalStatus: QualApprovalStatus;
};

export enum QualApprovalStatus {
  AwaitingCceaApproval = 0,
  AwaitingOfqualApproval = 1,
  Rejected = 2,
  Approved = 3
}

export const fromApiModel = (model: Model): Qualification => {
  return {
    ...model
  } as Qualification;
};

export const toApiModel = (item: Qualification): Model => {
  return {
    ...item,
  } as Model;
};

export const defaultValues: Partial<Qualification> = {
  title: "",
  organisationId: "",
  organisationReferenceNumber: null,
  linkToSpecification: "",
  qualLevel: "",
  qualSubLevel: "",
  qualificationType: null,
  epaStandardId: null,
  qualGLH: null,
  qualTQT: null,
  qualCredit: null,
  qualSectorSubjectArea: null,
  overallGradingType: null,
  gradingScale: null,
  qualAssessmentMethods: [],
  specialism: null,
  operationalStartDate: "",
  operationalEndDate: "",
  qualificationReviewDate: "",
  certificationEndDate: "",
  offeredInternationally: null,
  optionalRoutesToCompleteQual: null,
  isThisQualificationPrivate: false,
  fundingInNorthernIreland: false,
  fundingInEngland: false,
  nineteenPlus: false,
  eighteenPlus: false,
  sixteenToEighteen: false,
  preSixteen: false,
  offeredInNorthernIreland: false,
  offeredInEngland: false,
  niDiscountCode: null,
  entitlementFrameworkDesignation: null,
  gcseSizeEquivalence: null,
  gceSizeEquivalence: null,
  approvedForDELFundedProgramme: null,
};